import React from 'react';
import { GQL } from '@gin-betting/core';

import { AsyncBetslipFreebet } from 'modules/freebet/async';
import BetslipStakeInput from '../../BetslipStakeInput';
import TotalRow from '../TotalRow';
import useSinglePart from './useSinglePart';

interface Props {
    betslipBetId: string;
}

const SinglePart: React.FC<Props> = ({ betslipBetId }) => {
    const {
        singleStake,
        totals: { totalWin },
        maxStake,
        changeStakeHandler,
        isFreebet,
        betslipOddIds,
        isSuspended,
        onKeyDown,
    } = useSinglePart({ betslipBetId });

    return (
        <React.Fragment>
            <AsyncBetslipFreebet
                toggleFreebetCallback={changeStakeHandler}
                betslipOddIds={betslipOddIds}
                betType={GQL.BetType.SINGLE}
                isFreebetInProcess={isSuspended}
            />
            {!isFreebet && (
                <BetslipStakeInput
                    maxStake={maxStake}
                    changeValue={changeStakeHandler}
                    value={singleStake}
                    isDisabled={isFreebet}
                    onKeyDown={onKeyDown}
                />
            )}
            <TotalRow
                betslipBetId={betslipBetId}
                totalStake={+singleStake}
                totalPotentialWin={totalWin}
                isFreebetSelected={isFreebet}
            />
        </React.Fragment>
    );
};

export default React.memo(SinglePart);
